<template>
  <divcard>
    <div class="d-flex align-center justify-space-between" :class="{ 'card-part': expanded }">
      <div class="txt-head black--text">
        แผนงาน บริหารจัดการอาคาร
      </div>

      <div  class="d-flex align-center gap-8">
        <SwitchInset
                :disabled="disabled"
                :input-value="status"
                style="transform: translateY(-2px);"
                true-value="Active"
                false-value="Inactive"
                @onChange="setStatus($event)"

            ></SwitchInset>
            <span class="mr-2"  style="min-width: 70px;">{{ status === 'Active' ? 'เปิดแผน' : 'ปิดแผน' }}</span>
      <v-btn icon :class="{ 'rotate180': expanded }" @click="expanded = !expanded">
        <Iconify
            icon="material-symbols:keyboard-arrow-down"
            color="var(--theme-color-seven)"
        ></Iconify>
      </v-btn>
      </div>
    </div>

    <div
        class="d-flex flex-column gap-12 expandable"
        :class="{ 'expanded card-part': expanded }"
    >
      <div>
        <div class="mb-1 black--text">หลักการและเหตุผล</div>
        <TextArea
            theme="3"
            :value="form?.principle"
            @onChange="setFormField('principle', $event)"
            :readonly="previewCheck"
        ></TextArea>
      </div>

      <div>
        <div class="mb-1 black--text">วัตถุประสงค์</div>
        <TextArea
            theme="3"
            :value="form?.objective"
            @onChange="setFormField('objective', $event)"
            :readonly="previewCheck"
        ></TextArea>
      </div>

      <div>
        <div class="mb-1 black--text">เป้าหมาย</div>
        <TextArea
            theme="3"
            :value="form?.target"
            @onChange="setFormField('target', $event)"
            :readonly="previewCheck"
        ></TextArea>
      </div>

      <div>
        <div class="mb-1 black--text">เงื่อนไข</div>
        <TextArea
            theme="3"
            :value="form?.condition"
            @onChange="setFormField('condition', $event)"
            :readonly="previewCheck"
        ></TextArea>
      </div>

      <div>

        <!-- <div class="mb-5">
          <div v-if="masterData.evaluate_layout">
            <router-link :to="{ name: 'ConsiderFormEdit', params: { id: masterData.evaluate_layout.id }}" target="_blank" class="theme-color-one">
              แบบฟอร์มการพิจารณาและลงคะแนน (V.{{ masterData.evaluate_layout.version }})
            </router-link>
          </div>
        </div> -->

        <div class="d-flex justify-space-between mb-3">
          <div class="txt-head black--text">เอกสารแนบ</div>

          <Button
              theme="6"
              @onClick="addAttachment"
              v-if="!previewCheck"
          >
            + เพิ่มไฟล์
          </Button>
        </div>

        <div class="theme-color-seven mb-2">*ไฟล์ที่ระบบรองรับ .PDF/.doc (สูงสุด 50 MB/ไฟล์)</div>
        <v-layout class="mt-3" v-for="(file, f) in attachment" :key="f">
          <v-flex xs7>
            <v-file-input
                ref="fileInput"
                v-model="files[f]"
                :id="'file' + f"
                :rules="rulesFile"
                color="#F15A29"
                :clearable="false"
                style="border-radius: 30px"
                outlined
                height="36"
                placeholder=""
                prepend-icon=""
                accept="application/pdf,.doc,.docx"
                v-show="
                      checkValType(file.file_name) == 'object' ||
                      file.file_name == '' ||
                      file.file_name == null
                    "
                @change="addToAttachment(files[f], f)"
            ></v-file-input>
            <v-text-field
                v-show="checkValType(file.file_name) == 'string'"
                v-model="file.file_name"
                outlined
                height="36"
                color="#F15A29"
                style="border-radius: 30px"
                readonly
            ></v-text-field>
          </v-flex>
          <v-flex shrink ml-3>
            <v-btn
                depressed
                dark
                rounded
                width="100"
                color="#464647"
                @click="selectFile(f)"
                v-if="!previewCheck"
            >
              <v-icon class="font-12 font-w-700" left>mdi-upload</v-icon>
              <span class="font-12 font-w-700">อัพโหลด</span>
            </v-btn>
          </v-flex>
          <v-flex shrink ml-3>
            <v-btn
                depressed
                height="35"
                width="35"
                fab
                dark
                color="#FD0C0C"
                @click="removeFile(f)"
                v-if="!previewCheck"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>

      </div>
    </div>
  </divcard>
</template>

<script>
import TextArea from "../../../components/input/TextArea"
import AutoBox from "../../../components/input/AutoBox"
import Button from "../../../components/input/Button"
import { eventBus } from "../../../plugins/global-funcs"
import SwitchInset from "../../../components/input/SwitchInset";

export default {
  name: "FormManageBuilding",
  components: {
    TextArea,
    SwitchInset,
    AutoBox,
    Button
  },
  props: {
    masterData: {
      default: () => ({})
    },
    previewCheck: {
      default: () => (false)
    },
    status: {
      default: () => ('Inactive')
    },
    disabled: {
      default: () => (false)
    }
  },
  data () {
    return {
      expanded: false,
      form: {},

      files: [],
      attachment: [{}],
      rulesFile: [
        (value) => !!value || "กรุณาแนบเอกสาร",
        (value) => (!value || value.size <= 50000000) || "ขนาดไฟล์ต้องน้อยกว่า 50 MB!",
      ],
    }
  },
  watch: {
    files: {
      handler (val) {
        this.form.attachments = this.attachment
        console.log('this.form.attachments@watch', this.form.attachments)
      },
      deep: true
    }
  },
  created() {
    // this.form = this.AttachmentForm
    eventBus.$on('mainProjectFormManageBuilding', () => {
      eventBus.$emit('mainProjectFormManageBuildingSend', this.form)
    })
    eventBus.$on('mainProjectFormManageBuilding', (data) => {
      this.form = data ?? {}
      this.attachment = data?.attachments ?? [{}]
    })
  },
  methods: {
    setFormField(field, val) {
      this.form[field] = val
      this.$forceUpdate()
    },
    setStatus(event) {
      console.log('event', event);
      //this.setFormField('status', event)
      this.$emit('update:status', event); 

    },
    addAttachment () {
      this.attachment.push({})
      this.form.attachments = this.attachment
      console.log('addAttachment')
    },
    addToAttachment(file, i){
      console.log('file size', file.size)
      //check if file size > 10mb then show dialog modal
      if(file.size > 50000000){
        this.$store.commit('General/setModal', {
          title: 'ขนาดไฟล์เกิน 50 MB',
          theme: 'warning',
          text: 'กรุณาแนบไฟล์ที่มีขนาดไม่เกิน 50 MB',
          showCancel: false,
          buttonText: 'ตกลง'
        })
        //remove file in to last index of attachment
        this.attachment.pop()
        this.files.pop()
        return
      }
      this.attachment[i] = file
      console.log('addToAttachment', this.attachment)
    },
    removeFile(id) {
      this.attachment.splice(id, 1);
      this.files.splice(id, 1);
      this.form.attachments = this.attachment
      console.log('removeFile', this.form.attachments)
    },
    selectFile(id) {
      // querySelector id file จากนั้นเรียก event click
      // document.querySelector("#file" + id).click();
      this.$refs.fileInput[id].$el.querySelector('input[type="file"]').click();
    },
    checkValType(val) {
      return typeof val;
    },
  }
}
</script>

<style scoped lang="scss">

</style>